import React, { Suspense, lazy } from 'react';

import { ALL_POI_TYPE_IDS } from '../poiStaticRepository';
import useAppState from '../hooks/useAppState';
import useParentHistoryMutation from '../hooks/useParentHistoryMutation';
import EmbeddedFooter from './EmbeddedFooter';
import Footer from './Footer';
import MapboxGlSupportBoundry from './MapboxGlSupportBoundry';
import OnboardingBoundry from './OnboardingBoundry';
import StaticBackdrop from './StaticBackdrop';

const HUD = lazy(() => import('./HUD'));
const Map = lazy(() => import('./Map'));

const initialState = {
  bounds: null,
  cardProperties: {},
  center: [-98.0, 38.0],
  filter: ALL_POI_TYPE_IDS,
  fitBounds: null,
  isCardActive: false,
  mapStyleKey: 'terrain',
  shouldCenter: true,
  speciesFilter: -1,
  zoom: [4.1],
  searchType: '',
  searchString: '',
};

const App = () => {
  useParentHistoryMutation();
  const [appState, setAppState] = useAppState(initialState);

  return (
    <>
      <div className="main">
        <OnboardingBoundry setParentState={setAppState}>
          <MapboxGlSupportBoundry>
            <Suspense fallback={<StaticBackdrop><div className="loader loader-prompt" /></StaticBackdrop>}>
              <HUD
                setParentState={setAppState}
                {...appState} // eslint-disable-line react/jsx-props-no-spreading
              />
              <Map
                setParentState={setAppState}
                {...appState} // eslint-disable-line react/jsx-props-no-spreading
              />
            </Suspense>
          </MapboxGlSupportBoundry>
        </OnboardingBoundry>
      </div>
      {process.env.IS_EMBEDDED ? <EmbeddedFooter /> : <Footer />}
    </>
  );
};

export default App;
